import React from 'react';
import styles from './ShotLocationChanger.module.scss';
import { LabeledDropdown, Button } from 'components';
import { inject } from 'mobx-react';
import { EDITOR_LOCATIONS_STORE, EDITOR_SHOTS_STORE } from 'store';
import { ShotLocationChangerProps } from './types';

const ShotLocationChanger = (props: ShotLocationChangerProps) => {
  const {
    [EDITOR_LOCATIONS_STORE]: {
      locationNames
    },
    [EDITOR_SHOTS_STORE]: {
      moveSelectedShotsToLocation
    }
  } = props;
  const [selectedLocation, setSelectedLocation] = React.useState('');

  return (
    <div className={styles.locationChangerContainer}>
      <LabeledDropdown
        options={locationNames}
        selectedOptions={[selectedLocation]}
        onSelect={([value]) => setSelectedLocation(value)}
        placeholder='Move to location'
        size='mini'
        className={styles.locationChangeDropdown}
        // optionClassName={styles.option}
      />
      <Button
        size='mini'
        type='add'
        onClick={() => moveSelectedShotsToLocation(selectedLocation)}
      >
        Go
    </Button>
    </div>
  );
};

export default inject(EDITOR_LOCATIONS_STORE, EDITOR_SHOTS_STORE)(ShotLocationChanger);
